export const OAUTH_EVENTS = {
  SILENTLY_REFRESHED: 'silently_refreshed',
};
